// extracted by mini-css-extract-plugin
module.exports = {"segment":"segment-34rr-","checked":"checked-tAeFI","segment_active":"segment_active-3dKn2"};